import { MoPortfolioItem } from './my-org-portfolio.model';
import { INVENTED_DATA_ENABLED } from 'src/services/demo-backend/invented-data';

/** The icon a piece's thumbnail shows, by its kind of work (the profile mockup's thumbnails). */
export const PORTFOLIO_PIECE_ICON: Record<string, string> = {
  Dubbing: 'mat:movie', Translation: 'mat:description', 'Voice recording': 'mat:graphic_eq', Subtitling: 'mat:subtitles',
};

/**
 * The portfolio's sample pieces (no portfolio endpoint exists yet). Kept in its own file so the
 * Organization › Profile sample layer can offer the same pieces without loading this page.
 */
const SAMPLE_PIECES: MoPortfolioItem[] = [
  {
    id: 'pi1',
    title: 'Annual Report 2023 — Financial Summary',
    category: 'Translation',
    color: '#0ea5e9',
    tags: ['Finance', 'Annual Report', 'EN → ES'],
    description: 'Full translation of a 120-page annual financial report from English to Spanish, including charts, tables and footnotes.',
    isPublic: true,
    viewCount: 142,
    thumbUrl: '',
    files: [
      {
        id: 'f1',
        title: 'Annual Report Cover',
        attachments: [
          { id: 'a1', name: 'cover.pdf', url: '', type: 'file' },
        ],
      },
    ],
    startDate: '2023-01-10',
    endDate: '2023-02-28',
  },
  {
    id: 'pi2',
    title: 'Medical Device Manual — Post-Edit',
    category: 'Post-Translation Editing',
    color: '#8b5cf6',
    tags: ['Medical', 'Technical', 'FR → EN'],
    description: 'Post-editing of a machine-translated medical device manual (French to English), ensuring regulatory compliance.',
    isPublic: true,
    viewCount: 87,
    thumbUrl: '',
    files: [],
    startDate: '2023-04-01',
    endDate: '2023-04-20',
  },
  {
    id: 'pi3',
    title: 'Marketing Campaign — Subtitles Pack',
    category: 'Professional Subtitling',
    color: '#f59e0b',
    tags: ['Marketing', 'Video', 'EN → DE'],
    description: 'Subtitling of 8 promotional videos (total 45 min) for a pan-European product launch campaign.',
    isPublic: false,
    viewCount: 33,
    thumbUrl: '',
    files: [],
    startDate: '2023-06-15',
    endDate: '2023-07-01',
  },
  {
    id: 'pi4',
    title: 'Legal Contract Package',
    category: 'Translation',
    color: '#22c55e',
    tags: ['Legal', 'Contract', 'IT → EN'],
    description: 'Translation of a multi-document legal contract package from Italian to English for an M&A transaction.',
    isPublic: true,
    viewCount: 210,
    thumbUrl: '',
    files: [],
    startDate: '2022-11-01',
    endDate: '2022-12-15',
  },
];

/**
 * The portfolio's in-browser store: the piece editor adds to it in place. It starts with the sample
 * pieces only while invented data is on; otherwise a new organization starts with an empty
 * portfolio and sees only what it adds.
 */
export const PORTFOLIO_DUMMY: MoPortfolioItem[] = INVENTED_DATA_ENABLED ? SAMPLE_PIECES : [];
